// Stream
export const HubPageService_StreamLazy = () =>
  import("./service.grpc").then((m) => m.HubPageService_Stream);
HubPageService_StreamLazy.method =
  "aysa_api.services.hub_page.HubPageService/Stream" as const;

// Metadata [Web only]
export const HubPageService_MetadataLazy = () =>
  import("./service.grpc").then((m) => m.HubPageService_Metadata);
HubPageService_MetadataLazy.method =
  "aysa_api.services.hub_page.HubPageService/Metadata" as const;

// HeroBrandElement
export const HubPageService_HeroBrandElementLazy = () =>
  import("./service.grpc").then((m) => m.HubPageService_HeroBrandElement);
HubPageService_HeroBrandElementLazy.method =
  "aysa_api.services.hub_page.HubPageService/HeroBrandElement" as const;
